export default "__VITE_ASSET__5737af40__"